import type { FunctionComponent } from 'react';
import React, { Suspense } from 'react';

import { ChunkLoadErrorBoundary, ErrorBoundary } from '@trello/error-reporting';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { ListStatusPickerProps } from './ListStatusPicker';

export const LazyListStatusPicker: FunctionComponent<ListStatusPickerProps> = (
  props,
) => {
  const ListStatusPicker = useLazyComponent(
    () =>
      import(/* webpackChunkName: "list-status-picker" */ './ListStatusPicker'),
    { namedImport: 'ListStatusPicker' },
  );

  return (
    <ErrorBoundary
      tags={{
        ownershipArea: 'trello-workflowers',
        feature: 'List Status Picker',
      }}
    >
      <Suspense fallback={null}>
        <ChunkLoadErrorBoundary fallback={null}>
          <ListStatusPicker {...props} />
        </ChunkLoadErrorBoundary>
      </Suspense>
    </ErrorBoundary>
  );
};
